// extracted by mini-css-extract-plugin
export default {"row":"Headaches_row__cV8Md","col1":"Headaches_col1__U3C0I","col2":"Headaches_col2__JaPnI","col3":"Headaches_col3__XheLM"};